import { Button, ButtonSize, ButtonVariant } from "shared/components/Button";
import { StateOverrideRow } from "./StateOverrideRow";
import { ENROLLMENT_TYPE_OPTIONS } from "../constants";
import { Select, Option } from "shared/components/forms/Select";
import { PlusSignIcon } from "@hugeicons-pro/core-stroke-rounded";
import {
  Tooltip,
  TooltipContent,
  TooltipTrigger
} from "shared/components/Tooltip";

export const EnrollmentSettingsForm = ({
  defaultEnrollmentType,
  onDefaultEnrollmentTypeChange,
  stateOverrides,
  availableStates,
  onAddStateOverride,
  onUpdateStateOverride,
  onRemoveStateOverride,
  isLoadingStates,
  canAddStateOverride
}: {
  defaultEnrollmentType: string;
  onDefaultEnrollmentTypeChange: (value: string) => void;
  stateOverrides: { state: string; enrollmentType: string }[];
  availableStates: Option[];
  onAddStateOverride: () => void;
  onUpdateStateOverride: (
    index: number,
    field: "state" | "enrollmentType",
    value: string
  ) => void;
  onRemoveStateOverride: (index: number) => void;
  isLoadingStates: boolean;
  canAddStateOverride: boolean;
}) => {
  return (
    <form
      id="rent-reporting-settings-form"
      onSubmit={(e) => {
        e.preventDefault();
      }}
    >
      <div className="space-y-6">
        <div className="space-y-4">
          <Select
            id="default-enrollment-type"
            label="Default enrollment type"
            placeholder="Select enrollment type"
            value={defaultEnrollmentType || "na"}
            onChange={(e) => onDefaultEnrollmentTypeChange(e.target.value)}
            options={ENROLLMENT_TYPE_OPTIONS}
            required
          />
        </div>
        <div className="border-t border-alpha-40 pt-6 space-y-4">
          <h3 className="text-sm font-medium text-content-700 mb-2">
            State overrides
          </h3>
          {stateOverrides.map((override, index) => (
            <StateOverrideRow
              key={index + override.state}
              override={override}
              index={index}
              availableStates={availableStates}
              onUpdate={onUpdateStateOverride}
              onRemove={onRemoveStateOverride}
            />
          ))}
          {defaultEnrollmentType === "na" ? (
            <Tooltip>
              <TooltipTrigger>
                <Button
                  type="button"
                  variant={ButtonVariant.BASE}
                  size={ButtonSize.SM}
                  onClick={onAddStateOverride}
                  disabled={true}
                  HugeIcon={PlusSignIcon}
                >
                  {isLoadingStates ? "Loading states..." : "Add state override"}
                </Button>
              </TooltipTrigger>
              <TooltipContent className="max-w-[300px] rounded-lg z-[50] border bg-alpha-800 p-4 text-sm text-white">
                In order to add a state override, please add a default
                enrollment type
              </TooltipContent>
            </Tooltip>
          ) : (
            <Button
              type="button"
              variant={ButtonVariant.BASE}
              size={ButtonSize.SM}
              onClick={onAddStateOverride}
              disabled={isLoadingStates || !canAddStateOverride}
              HugeIcon={PlusSignIcon}
            >
              {isLoadingStates ? "Loading states..." : "Add state override"}
            </Button>
          )}
        </div>
      </div>
    </form>
  );
};
